import axios from 'axios'
import Log from '@/utilities/Log'
import { redactParams, redactUrl } from '@/utilities/redactRequestError'
import { version } from '~/package.json'
import { addOrAppendAxiosHeader } from '@/services/axios'

const requestDataInterceptor = (): void => {
  axios.interceptors.request.use(
    function (config) {
      config.headers = addOrAppendAxiosHeader(
        'x-verified-capture-version',
        version,
        config.headers,
      )

      Log.genericBreadcrumb('requestDataInterceptor', {
        data: JSON.stringify(config.data),
        method: config.method,
        params: JSON.stringify(redactParams(config.params)),
        url: redactUrl(config.url),
      })
      return Promise.resolve(config)
    },
    function (error) {
      return Promise.reject(error)
    },
  )
}

export default requestDataInterceptor
